/**
 * LoadingFallback.tsx
 * Suspense fallback component for lazy-loaded routes
 * Part of Week 9 Performance Optimization (Phase 1)
 */

import React from 'react';
import { Loader2 } from 'lucide-react';

export function LoadingFallback() {
  return (
    <div className="min-h-screen bg-gradient-to-br from-purple-900 via-black to-rose-900 flex items-center justify-center">
      <div className="text-center">
        <Loader2 className="w-16 h-16 text-rose-500 animate-spin mx-auto mb-4" />
        <p className="text-cream text-lg font-medium">Loading...</p>
      </div>
    </div>
  );
}

/**
 * Minimal loading fallback for components (no full-screen overlay)
 */
export function ComponentLoadingFallback() {
  return (
    <div className="flex items-center justify-center p-8">
      <Loader2 className="w-8 h-8 text-rose-500 animate-spin" />
    </div>
  );
}

/**
 * Skeleton loading for specific layouts
 */
export function PageLoadingSkeleton() {
  return (
    <div className="min-h-screen bg-gradient-to-br from-purple-900 via-black to-rose-900 pt-24 pb-12 px-4">
      <div className="max-w-7xl mx-auto">
        {/* Header skeleton */}
        <div className="mb-8 animate-pulse">
          <div className="h-10 bg-white/10 rounded w-64 mb-4"></div>
          <div className="h-6 bg-white/10 rounded w-96"></div>
        </div>

        {/* Content skeleton */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {[1, 2, 3].map((i) => (
            <div key={i} className="bg-white/5 rounded-2xl p-6 animate-pulse">
              <div className="h-32 bg-white/10 rounded-xl mb-4"></div>
              <div className="h-4 bg-white/10 rounded w-3/4 mb-2"></div>
              <div className="h-4 bg-white/10 rounded w-1/2"></div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
